import { useGetUserInfo } from '../services/api/user-info.hooks'

// An unpaid, expired trial keeps the app visible but read-only. Unknown (still loading) is not read-only.
const useIsReadOnly = () => {
    const { data: userInfo } = useGetUserInfo()
    return userInfo?.is_read_only ?? userInfo?.has_product_access === false
}

export default useIsReadOnly
